export default function ChainOfResponsibilityPage() {
  return (
    <ul>
      <li>Chain of Responsibility: </li>
    </ul>
  );
}
